import { useCallback, useEffect, useState } from "react";

import { CardCopTopUpsService } from "../services/cardCopTopUps.service";
import type { CardCopTopUpTerms } from "../types/cardCopTopUp.types";

interface Snapshot {
  cardId: string;
  terms: CardCopTopUpTerms | null;
  hasError: boolean;
}

export interface UseCardCopTopUpTermsResult {
  terms: CardCopTopUpTerms | null;
  isLoading: boolean;
  hasError: boolean;
  reload: () => void;
}

export function useCardCopTopUpTerms(cardId: string | null, enabled: boolean): UseCardCopTopUpTermsResult {
  const [snapshot, setSnapshot] = useState<Snapshot | null>(null);
  const [reloadToken, setReloadToken] = useState(0);
  const key = enabled && cardId ? cardId : null;

  useEffect(() => {
    if (!key) return;
    let cancelled = false;
    CardCopTopUpsService.terms(key)
      .then((terms) => {
        if (!cancelled) setSnapshot({ cardId: key, terms, hasError: false });
      })
      .catch(() => {
        if (!cancelled) setSnapshot({ cardId: key, terms: null, hasError: true });
      });
    return () => {
      cancelled = true;
    };
  }, [key, reloadToken]);

  const reload = useCallback(() => setReloadToken((token) => token + 1), []);
  const current = key && snapshot?.cardId === key ? snapshot : null;

  return {
    terms: current?.terms ?? null,
    isLoading: !!key && current === null,
    hasError: current?.hasError ?? false,
    reload,
  };
}
